<hr />
<div class="row my-2">
  <div class="col-sm-4">
    <h6>
      <img
        class="p-2"
        ngSrc="../../../assets/images/icons/semirremolques.svg"
        alt="Semirremolques"
        height="50"
        width="50"
      />
      {{ entityName }}
    </h6>
  </div>
  <div class="col-sm-8 text-end">
    <div class="input-search-container-new">
      <span class="material-symbols-outlined search-icon"> search </span>
      <input
        placeholder="Buscar"
        class="input-search-datatable"
        id="custom-search-input"
        type="text"
        [(ngModel)]="searchText"
        (input)="applyFilter()"
      />
    </div>
    <button
      id="semirremolques-list-new"
      class="btn-btn-create"
      (click)="onNewSemirremolque()"
      *ngIf="showButton('create')"
    >
      Crear {{ entityName }}
    </button>
    <button
      id="semirremolques-list-refresh"
      class="btn mx-2 btn-refresh"
      (click)="onRefresh()"
    >
      <span class="material-symbols-outlined"> refresh </span>
    </button>
  </div>
</div>
<div class="row">
  <div class="text-center my-5" *ngIf="isGettingSemirremolques">
    <app-spinner message="Cargando {{ entityName }}"></app-spinner>
  </div>
  <div class="col-xs-12">
    <div class="table-responsive-sm" *ngIf="!isGettingSemirremolques">
      <table
        datatable
        [dtOptions]="dtOptions"
        class="table display nowrap"
        style="width: 100%"
      >
        <caption>
          Lista de Vehículos
        </caption>
        <thead>
          <tr class="text-center">
            <th
              scope="col"
              *ngFor="let attribute of semirremolquesAttributes"
              [hidden]="hideColumn(attribute)"
            >
              {{ attribute }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let semirremolque of semirremolques">
            <td>
              <a
                id="semirremolques-list-{{ semirremolque.licensePlate }}"
                (click)="onSelectedSemirremolque(semirremolque)"
                style="color: #0d6efd"
                >{{ semirremolque.sapId! | sapId }}</a
              >
            </td>
            <td>
              <span>
                <img
                  [ngSrc]="getImageSrc(semirremolque.status)"
                  height="25"
                  width="25"
                  alt="Estado"
                />
              </span>
              {{ semirremolque.status | master : "VEHICLES#STATUSES" }}
            </td>
            <td>{{ semirremolque.licensePlate }}</td>
            <td [hidden]="hideColumn('Transportista')">
              {{ semirremolque.carrier!.name }}
            </td>
            <td>{{ semirremolque.center | master : "CENTERS" }}</td>
            <td>
              <span
                class="badge border rounded-4 text-bg-light mx-1"
                *ngIf="hasToExpireDocuments(semirremolque)"
              >
                <span class="badge border rounded-circle text-bg-light">{{
                  semirremolque.documentsToExpire
                }}</span>
                por vencer</span
              >
              <span
                class="badge border rounded-4 text-bg-light mx-1"
                *ngIf="hasExpiredDocuments(semirremolque)"
              >
                <span class="badge border rounded-circle text-bg-light">{{
                  semirremolque.documentsExpired
                }}</span>
                vencido</span
              >
            </td>
            <td>
              <span
                class="badge border rounded-4 text-bg-light mx-1"
                *ngFor="let blockingMotive of semirremolque.blockingMotives"
              >
                {{ blockingMotive }}</span
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
